import fundacion from '../assets/Fundacion Santa Fe de Bogota.png';
import fortecem from '../assets/Fortecem.png';
import roche from '../assets/Roche.png';
import segurosbolivar from '../assets/Seguros Bolivar.png';
import zinzaja from '../assets/Wavin Pavco Zin Zanja.png';
import enel from '../assets/ENEL.png';
import constructorabolivar from '../assets/Constructora Bolivar.png';
import colsubsidio from '../assets/Colsubsidio.png';
import asogravas from '../assets/Asogravas.png';
import eduardono from '../assets/Eduardono.png';
import unilever from '../assets/Unilever.png';
import piscilago from '../assets/Colsubsidio Piscilago.png';
import govideo from '../assets/LOGO-3GOVIDEO-128.png';
import ara from '../assets/Jeronimo Martins Ara.png';
import maseq from '../assets/Masseq.png';

const Clients = () => {

return(
    <div className="container mt-5">
        <h1 className="section-title">Clientes que han creido en nosotros</h1>
        <div className="clients-logos">
            <div>
            <img src={fundacion} alt="logo fundacion santafe"></img>
        </div>
        <div>
            <img src={fortecem} alt="logo fortecem"></img>
        </div>
        <div>
            <img src={segurosbolivar} alt="logo seguros bolivar"></img>
        </div>
        <div>
            <img src={roche} alt="logo Roche"></img>
        </div>
        <div>
            <img src={zinzaja} alt="logo Zinzaja"></img>
        </div>
        <div>
            <img src={enel} alt="logo enel"></img>
        </div>
        <div>
            <img src={constructorabolivar} alt="logo constructora bolivar"></img>
        </div>
        <div>
            <img src={colsubsidio} alt="logo colsubsidio"></img>
        </div>
        <div>
            <img src={asogravas} alt="logo asogravas"></img>
        </div>
        <div>
            <img src={eduardono} alt="logo eduardoño"></img>
        </div>
        <div>
            <img src={unilever} alt="logo unilever"></img>
        </div>
        <div>
            <img src={piscilago} alt="logo piscilago"></img>
        </div>
        <div>
            <img src={govideo} alt="logo 3GOVideo"></img>
        </div>
        <div>
            <img src={ara} alt="logo ara"></img>
        </div>
        <div>
            <img src={maseq} alt="logo constructora maseq"></img>
        </div>
        </div>
        
    </div>
)
}

export default Clients;